import {  Modal } from "antd";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

const SlotsModal = ({ slotsModal = false, setSlotsModal }) => {
  // const [form] = Form.useForm();
  // const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();

  // const onFinish = async (values) => {
  //   try {
  //     setLoading(true);
  //     setSlotsModal(false);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  const CustomBox = ({ day }) => (
    <div className="flex justify-between items-center border border-[#D9D9D9] bg-white p-2 mb-2 w-full">
      <h5 className="font-euclid uppercase text-black text-sm max-md:text-xs">
        {day}
      </h5>
      <button className="uppercase bg-[#576C7E] py-3 px-4 text-white rounded-sm font-bold text-xs max-md:text-[10px]">
        Add slot
      </button>
    </div>
  );

  const days = [
    {
      index: 1,
      day: "Monday",
    },
    {
      index: 2,
      day: "Tuesday",
    },
    {
      index: 3,
      day: "Wednesday",
    },
    {
      index: 4,
      day: "Thursday",
    },
    {
      index: 5,
      day: "Friday",
    },
    {
      index: 6,
      day: "Saturday",
    },
    {
      index: 7,
      day: "Sunday",
    },
  ];

  return (
    <div>
      <Modal
        centered
        open={slotsModal}
        footer={null}
        onCancel={() => setSlotsModal(false)}
      >
        <div className="flex flex-col justify-center items-center bg-white desktop:py-4">
          <h3 className="font-tavi text-2xl text-customBlack max-desktop:text-xl max-sm:text-lg text-center my-8 font-semibold">
            Slots
          </h3>
          <div className="flex flex-col items-center justify-center w-full">
            {days.map((item) => (
              <CustomBox key={item.index} day={item.day} />
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SlotsModal;
